var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.removeActivation)?_c('div',{class:_vm.classObject},[_c('div',{staticClass:"m-auto test-image"},[_c('P5Sketch',{attrs:{"name":"DotCloud","dimensions":{ width: _vm.sketchWidth, height: _vm.sketchHeight }},on:{"user-interaction":_vm.removeOverlay}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3910bda0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioActivation.vue
// module id = null
// module chunks = 